<template>
  <div
    v-if="!loggingIn"
    class="login_cont"
  >
    <div
      v-if="appleLoginInProgress"
      class="anim-fade-in"
      style="
        position: fixed;
        z-index: 10;
        width: 100%;
        height: 100%;
        opacity: 0.5;
        background-color: #000000;
      "
    ></div>
    <LangMenu :onTopRight="true" />
    <div class="login_left anim-fade-in_slow">
      <h1 class="text-big weight_500">
        {{ $t('login.message_0') }}
        <span class="clr-primary">
          {{ $t('login.message_1') }}
        </span>
      </h1>

      <div class="mt-4">
        <h2
          v-for="item in whyOpts"
          :key="item.text"
          class="clr-grey d-flex f-align-center text-normal mt-8 weight_500"
        >
          <v-icon
            size="large"
            class="mr-4"
            >{{ item.icon }}</v-icon
          >
          <div>
            {{ item.text }}
          </div>
        </h2>
      </div>
    </div>
    <div class="login_right">
      <div class="f-column">
        <div class="logo">
          <Logo />
        </div>

        <div class="login_title anim-fade-in_slow mt-8">
          {{ $t('login.title') }}
        </div>
      </div>

      <div class="login_btns f-wrap f-center anim-fade-in_slow mt-6">
        <div
          v-ripple
          class="login_btn login_btn_red"
          @click="gLogin"
        >
          <div class="login_btn_content">
            <!-- <i
              style="font-size: 62px; color: white; line-height: 1"
              class="mdi mdi-google login_btn_logo"
            ></i> -->
            <svg
              style="height: 52px"
              viewBox="0 0 90 92"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M89.975 47.0031C89.975 43.9031 89.675 40.7031 89.175 37.7031H45.875V55.4031H70.675C69.675 61.1031 66.375 66.1031 61.475 69.3031L76.275 80.8031C84.975 72.7031 89.975 60.9031 89.975 47.0031Z"
                fill="#4280EF"
              />
              <path
                d="M45.875 91.8008C58.275 91.8008 68.675 87.7008 76.275 80.7008L61.475 69.3008C57.375 72.1008 52.075 73.7008 45.875 73.7008C33.875 73.7008 23.775 65.6008 20.075 54.8008L4.875 66.5008C12.675 82.0008 28.475 91.8008 45.875 91.8008Z"
                fill="#34A353"
              />
              <path
                d="M20.075 54.7008C18.175 49.0008 18.175 42.8008 20.075 37.1008L4.875 25.3008C-1.625 38.3008 -1.625 53.6008 4.875 66.5008L20.075 54.7008Z"
                fill="#F6B704"
              />
              <path
                d="M45.875 18.2017C52.375 18.1017 58.775 20.6017 63.475 25.1017L76.575 11.9017C68.275 4.10174 57.275 -0.0982547 45.875 0.00174529C28.475 0.00174529 12.675 9.80175 4.875 25.3017L20.075 37.1017C23.775 26.2017 33.875 18.2017 45.875 18.2017Z"
                fill="#E54335"
              />
            </svg>
            <div class="login_btn_text">GOOGLE</div>
          </div>
        </div>
        <div
          v-ripple
          class="login_btn login_btn_blue"
          @click="fbLogin"
        >
          <div class="login_btn_content">
            <i
              style="font-size: 62px; line-height: 1"
              class="mdi mdi-facebook login_btn_logo"
            ></i>
            <div class="login_btn_text">FACEBOOK</div>
          </div>
        </div>
        <div
          v-ripple="!appleScriptLoading"
          :class="{ login_btn_loading: appleScriptLoading }"
          class="login_btn login_btn_black"
          @click="setAppleInProgress(true)"
        >
          <div class="login_btn_content">
            <i
              style="font-size: 62px; color: white; line-height: 1"
              class="mdi mdi-apple login_btn_logo"
            ></i>
            <div class="login_btn_text">APPLE</div>
          </div>
          <div
            id="appleid-signin"
            data-mode="logo-only"
            data-height="100%"
            style="width: 100%; height: 100%; opacity: 0; position: absolute; z-index: 4"
          />
        </div>
      </div>
      <div
        class="uppercase mt-16 weight_500 f-center"
        style="color: var(--clr-black-6)"
      >
        <i class="mdi mdi-chevron-left text-large"></i>
        <div>
          <a
            style="color: inherit"
            :href="homepageUrl"
            class="link-underline link-underline_hover cursor-pointer"
            v-html="$t('login.go_home')"
          ></a>
        </div>
      </div>

      <div
        v-if="!noMagicLogin"
        :data-tst="'open_magic_login'"
        style="position: fixed; bottom: 0; height: 3rem; width: 100vw"
        @click="showMagicLogin"
      ></div>

      <MagicLogin
        v-if="!noMagicLogin && $route.query.login === 'login'"
        @login:google="gLogin"
        @login:facebook="fbLogin"
      >
      </MagicLogin>
    </div>
  </div>
</template>

<script>
import MagicLogin from '@/views/single/Login/MagicLogin'
import Logo from '@/assets/logo.svg'
import { gtm_refferal_link } from '@/helpers/gtm'
import { getCookie, deleteCookie } from '@gto/helpers/cookies'
import LangMenu from '@/components/LangSwitcher/LangMenu'
import { sessionStore } from '@gto/gw-store'
import { loadScript } from 'vue-plugin-load-script'

export default {
  name: 'Login',
  components: {
    Logo,
    LangMenu,
    MagicLogin,
  },
  data() {
    this.fb = 'login?logservice=facebook'
    this.g = 'login'
    this.noMagicLogin = window.location.href.includes('https://app.gtowizard.com/')
    return {
      loggingIn: false,
      appleScriptLoading: true,
      appleLoginInProgress: false,
    }
  },
  mounted() {
    const { code, logservice, state } = this.$route.query

    // FE Feature flag: There are no BE Feature flags before login
    // if (flag) {
    //   const currentFlags = localStorage.getItem('featureFlags')?.split(',') || []
    //   const flags = uniq([...currentFlags, flag])
    //   localStorage.setItem('featureFlags', flags.toString())
    // }

    if (code && code !== localStorage.getItem('socialCode')) {
      const gclid = getCookie('GTO_GCLID')
      const appUid = sessionStore.getState().appUid
      const params = {
        code,
        logservice,
        state,
        gclid,
        appUid,
      }

      const aid = getCookie('GTO_AFFILIATE_ID')
      if (aid) {
        params.affiliate_id = aid
        gtm_refferal_link()
      }
      localStorage.setItem('socialCode', code)

      this.handleRedirectFromService(params)
    } else {
      loadScript(
        'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js',
      ).then(() => {
        window.AppleID.auth.init({
          clientId: this.isDev ? 'com.gtowizard.dev.app' : 'com.gtowizard.app',
          redirectURI: this.isDev
            ? 'https://app.dev.gtowizard.com/login/'
            : 'https://app.gtowizard.com/login/',
          scope: 'email name',
          state: Date.now().toString(),
          usePopup: true,
        })

        this.appleScriptLoading = false
        document.addEventListener('AppleIDSignInOnSuccess', this.handleAppleAuth)
        document.addEventListener('AppleIDSignInOnFailure', () => this.setAppleInProgress(false))
      })

      this.$store.dispatch('auth_logout')
    }
  },
  beforeUnmount() {
    if (window.AppleID) {
      document.removeEventListener('AppleIDSignInOnSuccess', this.handleAppleAuth)
      document.removeEventListener('AppleIDSignInOnFailure', () => this.setAppleInProgress(false))
    }
  },
  methods: {
    showMagicLogin() {
      this.$router.replace({ query: { login: 'login' } }).catch(() => {})
    },
    // FE Feature flag: There are no BE Feature flags before login
    // hasFeatureFlag(flag) {
    //   return localStorage.getItem('featureFlags')?.includes(flag)
    // },
    setAppleInProgress(val) {
      this.appleLoginInProgress = val
    },
    login(data) {
      this.loggingIn = true
      this.$store.dispatch('login', data)
      deleteCookie('GTO_GCLID')
    },
    handleAppleAuth({
      detail: {
        authorization: { code, id_token },
      },
    }) {
      this.setAppleInProgress(false)

      // TODO refactor this and unify for all providers
      const affiliate_id = getCookie('GTO_AFFILIATE_ID')
      const gclid = getCookie('GTO_GCLID')
      const appUid = sessionStore.getState().appUid
      const data = {
        code,
        id_token,
        // all must be preset
        ...(affiliate_id ? { affiliate_id } : {}), // affiliate
        ...(gclid ? { gclid } : {}), // google ads-tracking
        ...(appUid ? { appUid } : {}), // multiaccount
        provider: 'apple-id',
        redirect_uri: this.isDev
          ? 'https://app.dev.gtowizard.com/login/'
          : 'https://app.gtowizard.com/login/',
      }
      this.login(data)
    },
    redirectToService(url) {
      window.location.href = url
    },
    handleRedirectFromService(response) {
      const { code, logservice, gclid, appUid, affiliate_id } = response
      if (logservice === 'facebook') {
        const data = {
          code,
          provider: 'facebook',
          redirect_uri: `${window.origin}/${this.fb}`,
          // all must be preset
          ...(affiliate_id ? { affiliate_id } : {}), // affiliate
          ...(gclid ? { gclid } : {}), // google ads-tracking
          ...(appUid ? { appUid } : {}), // multiaccount
        }

        this.login(data)
        return
      }

      const data = {
        code,
        provider: 'google-oauth2',
        redirect_uri: `${window.origin}/${this.g}`,
        // all must be preset
        ...(affiliate_id ? { affiliate_id } : {}), // affiliate
        ...(gclid ? { gclid } : {}), // google ads-tracking
        ...(appUid ? { appUid } : {}), // multiaccount
      }

      this.login(data)
    },
    fbLogin() {
      const fbAuth = {
        client_id: '1296122060595224',
        redirect_uri: `${window.origin}/${this.fb}`,
        response_type: 'code',
        scope: 'email',
      }
      const params = new URLSearchParams(fbAuth)
      const url = `https://www.facebook.com/v7.0/dialog/oauth?${params}`
      this.redirectToService(url)
    },
    // https://accounts.google.com/gsi/select
    // ?client_id=351360855136-c65vr13tal2in9b9m1hdmp5dgr4rie3l.apps.googleusercontent.com
    // &ux_mode=popup
    // &ui_mode=card
    // &as=Zdbarl3gmrSYDR%2FM5aX0kA
    // &channel_id=679773c2007fa18f565de6f27dadc04d2338e185f2d4dd8a402f0b0e93cb79ed
    // &origin=https%3A%2F%2Fdevelopers-dot-devsite-v2-prod.appspot.com
    gLogin() {
      const gAuth = {
        client_id: '984101650159-3ibpei4p5m5j5j97qu7j13jtb4i664td.apps.googleusercontent.com',
        redirect_uri: `${window.origin}/${this.g}`,
        response_type: 'code',
        scope: 'openid email profile',
        o2v: '1',
        as: 'ebtmicpwfh_79sjvh9yR6g',
        flowName: 'GeneralOAuthFlow',
      }
      const params = new URLSearchParams(gAuth)
      const url = `https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?${params}`
      this.redirectToService(url)
    },
  },
  computed: {
    isDev() {
      return import.meta.env.VITE_BRANCH !== 'master'
    },
    whyOpts() {
      return [
        {
          icon: 'mdi-school',
          text: this.$t('login.one', { num: `${(10000000).toLocaleString(this.$i18n.locale)}+` }),
        },
        { icon: 'mdi-google-controller', text: this.$t('login.two') },
        { icon: 'mdi-lightbulb-on', text: this.$t('login.three') },
      ]
    },
    homepageUrl() {
      const homepageUrl = `https://${window.location.hostname.replace('app.', '')}/${
        this.$i18n.g1 ? 'g1' : this.$i18n.locale
      }/`
      return homepageUrl
    },
  },
}
</script>
<style lang="scss" scoped>
@keyframes flipLogo {
  0% {
    opacity: 0;
    transform: rotateY(45deg);
  }
  100% {
    opacity: 1;
    transform: rotateY(0deg);
  }
}
.logo {
  color: var(--clr-primary);
  filter: drop-shadow(1px 0px 6px rgb(0, 172, 141, 0.25));
  fill: currentColor;
  animation: flipLogo 1.2s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    width: 7rem;
  }
}
.login {
  &_cont {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: var(--vh-100);
    width: 100vw;
    background: var(--clr-black-0);
  }
  &_left {
    width: 36.8rem;
    background: #191919;
    height: var(--vh-100);
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 3rem;
  }
  &_right {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex: 1;
  }
  &_title {
    font-size: 1.5rem;
    padding: 0rem 0.5rem 0.5rem 0.5rem;
    text-align: center;
    font-weight: 500;
  }
  &_btn {
    height: 12rem;
    width: 12rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    border-radius: 8px;
    margin: 1rem;
    position: relative;
    transition: 0.22s;

    &_red {
      --clr: 219, 68, 55;
      border: solid 2px rgba(var(--clr), 0.25);
      background: rgb(var(--clr), 0.1);
      &:hover {
        background: rgb(234, 67, 53, 0.2);
        border: solid 2px rgba(var(--clr), 0.8);
      }
    }
    &_blue {
      .login_btn_logo {
        --clr: 24, 119, 242;
        color: rgb(var(--clr));
      }
      --clr: 66, 103, 178;
      border: solid 2px rgba(var(--clr), 0.25);
      background: rgb(var(--clr), 0.1);
      &:hover {
        background: rgb(66, 103, 178, 0.2);
        border: solid 2px rgba(var(--clr), 0.8);
      }
    }
    &_black {
      border: solid 2px rgba(255, 255, 255, 0.125);
      // background: #090909;
      background: #000;
      &:hover:not(.login_btn_loading) {
        background: black;
        border: solid 2px rgba(255, 255, 255, 0.8);
      }
    }
    &_logo {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 52px;
    }
    &_text {
      margin-top: 1rem;
    }

    .login_btn_content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      user-select: none;
    }
    &:hover:not(.login_btn_loading) {
      cursor: pointer;
    }
    &_loading {
      opacity: 0.5;
      cursor: wait;
      .login_btn_content {
        pointer-events: none;
      }
    }
  }
}

@media (max-width: 1023px) {
  .login {
    &_left {
      display: none !important;
    }
    &_btn {
      margin: 0.5rem !important;
      height: 10rem !important;
      width: 10rem !important;
    }
  }
}
</style>
